// Invitation
export const FETCH_INVITATION_REQUEST = 'FETCH_INVITATION_REQUEST'
export const FETCH_INVITATION_SUCCESS = 'FETCH_INVITATION_SUCCESS'
export const FETCH_INVITATION_ERROR = 'FETCH_INVITATION_ERROR'
export const SET_INVITATION = 'SET_INVITATION'

// Invitation Modal
export const SET_INVITATION_MODAL_ID = 'SET_INVITATION_MODAL_ID'
export const SET_INVITATION_MODAL_IS_VISIBLE = 'SET_INVITATION_MODAL_IS_VISIBLE'

// Invitation Form
export const INVITATION_FORM_REQUEST = 'INVITATION_FORM_REQUEST'
export const INVITATION_FORM_SUCCESS = 'INVITATION_FORM_SUCCESS'
export const INVITATION_FORM_ERROR = 'INVITATION_FORM_ERROR'
export const SET_EMAIL_ADDRESSES = 'SET_EMAIL_ADDRESSES'
export const SET_ROLE = 'SET_ROLE'

// Invitations
export const FETCH_INVITATIONS_REQUEST = 'FETCH_INVITATIONS_REQUEST'
export const FETCH_INVITATIONS_SUCCESS = 'FETCH_INVITATIONS_SUCCESS'
export const FETCH_INVITATIONS_ERROR = 'FETCH_INVITATIONS_ERROR'
export const SET_INVITATIONS = 'SET_INVITATIONS'
export const DELETE_INVITATION = 'DELETE_INVITATION'
export const SET_META = 'SET_META'



// WEBPACK FOOTER //
// ./src/store/modules/invitations/types.js